import { Injectable } from '@angular/core';
import { NavigationService } from '@core/services/navigation/navigation.service';
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class ChangePinCodeCommand extends BaseProductCommand {
  readonly type = 'changePinCode';
  readonly title = 'Изменить ПИН';
  readonly icon = 'unlock';
  readonly productType = ProductTypes.CARD;
  readonly isInfoAction = true;
  readonly settingsNames = undefined;

  get order(): number {
    return this.getContextualOrder({
      [ProductTypes.CARD]: 70           // Карты: Изменить ПИН (7-й в списке "прочее")
    }, 999);
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private navigationService: NavigationService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    // TODO: Нужно добавить иконку карты из контекста
    // В оригинале: state: { product: { ...this.product, icon: this.card.icon } }
    this.navigationService.push(`product/${context.data.id}/change-pin`, {
      state: {
        product: {
          ...context.data,
          // icon: context.cardIcon // TODO: Добавить иконку когда будет доступна в контексте
        }
      }
    });
  }
}
